import './Footer.css';
import logo from '../../assets/icons/logo/logo.jpeg';

export default function Footer() {
    return (
        < div className="footer" >
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="footer-contact">
                            <h2>Contact Us</h2>
                            <a href="#"><p><i className="fa fa-map-marker-alt"></i>Cape Coast, Central Region Ghana</p></a>
                            <a href="tel:+233249664539"><p><i className="fa fa-phone"></i>+233 24 966 4539</p></a>
                            <a href="mailto:showbouysfoundationlbg20@gmail.com"><p><i className="fa fa-envelope"></i>showbouysfoundationlbg20@gmail.com</p></a>
                             <div className="footer-social">
                                 <a className="btn btn-custom" href="#"><i className="fab fa-x-twitter"></i></a>
                                 <a className="btn btn-custom" href="https://www.facebook.com/share/1AQ51dzgeD/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
                                 <a className="btn btn-custom" href="https://www.instagram.com/showbouysfoundationlbg?igsh=MWEyeWNqZTdpeGJreg==" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                                 <a className="btn btn-custom" href="https://www.youtube.com/channel/UCJnaNm8Ns08rUIhsdFM2fhA" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
                                 <a className="btn btn-custom" href="https://www.linkedin.com/company/vit-social-welfare-development/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>
                             </div>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-6">
                        <div className="footer-link">
                            <h2>Popular Links</h2>
                            <a href="/about">About Us</a>
                            <a href="/contact">Contact Us</a>
                            <a href="/event">Popular Causes</a>
                            <a href="/event">Upcoming Events</a>
                            <a href="#">Latest Blog</a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-link">
                            <h2>Useful Links</h2>
                            <a href="#">Terms of use</a>
                            <a href="#">Privacy policy</a>
                            <a href="#">Cookies</a>
                            <a href="#">Help</a>
                            <a href="#">FQAs</a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-newsletter">
                            <h2>Newsletter</h2>
                            <form name='NewsLetter'>
                                <input name='subscribe' className="form-control" placeholder="Email goes here" autoComplete='email' required/>
                                <button className="btn btn-custom">Submit</button>
                                <h6>Don't worry, we don't spam!</h6>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container copyright">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <p>&copy; <a href="#"><img src={logo} alt="Showbouys Foundation LBG Logo" style={{height: "30px", marginRight: "10px", borderRadius: "4px"}} />Showbouys Foundation LBG</a> | 2024, All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </ div>
    );
}